import { useEffect, useState } from "react";
import Back from "../../../components/goBack";
import Button from "../../../components/button";
import CampaignComments from "../../Campaigns/reuseableComponents/comments";
import updatesIcon from "../../../assets/icons/updatesIcon.svg";
import Donations from "../../Campaigns/reuseableComponents/donationList";
import { useParams } from "react-router-dom";
import { useCampaignDetail, useCampaignUpdates } from "../../reuseableEffects";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../../components/Spinners/Spinner";
import { useFormik } from "formik";
import * as Yup from "yup";
import { SendUpdates } from "../../../hooks/local/reducer";
import { showErrorMessage, showSuccessMessage } from "../../../hooks/constants";
// import GenerateCampaignFlyer from "./generateCampaignFlyer";

const UserCampaignDetail = ({setPageTitle}) => {

  const { campaignReference } = useParams();
  const campaignDetail = useCampaignDetail(campaignReference);
  const updates = useCampaignUpdates(campaignReference);

  const campaignImageURL = "https://mosquepay.org/mosquepaynew/assets/img/campaigns/";

  const dispatch = useDispatch()
  const loading = useSelector((state) => state.user.loading);

  const userSessionData = useSelector((state) => state.user.userSession);
  const userName = userSessionData.user_details[0].username;
  const userEmail = userSessionData.user_details[0].email;

  const sendUpdatesForm = useFormik({
    initialValues:{
      email:"",
      comment: "",
      campaign_id: "",
      campaign_owner: ""
    },
    validationSchema: Yup.object({
      comment: Yup.string().required("Please write an update"),
    }),
    onSubmit: async (values, {resetForm}) => {
      const {comment} = values;
      let sendUpdatesData = {campaign_id:campaignReference, campaign_owner:userName, email:userEmail, comment};
      console.log(sendUpdatesData);
      const payload = await dispatch(SendUpdates(sendUpdatesData));
      if(payload.payload.status_code === "0"){
        showSuccessMessage(payload.payload.message)
        resetForm();
        window.location.reload();
      } else { showErrorMessage(payload.payload.message)}
    }
  })

  const formattedAmountRaised = campaignDetail?.amount_raise?.replace(/,/g, "");
  const formattedAmount = campaignDetail?.amount?.replace(/,/g, "");

  const progress =
    formattedAmount > 0
      ? `${((formattedAmountRaised || 0) / formattedAmount) * 100}%`
      : "0%";

  const progressText =
    formattedAmount > 0
      ? `${((formattedAmountRaised || 0) / formattedAmount) * 100}`
      : "0";

  const formatedProgress = Math.ceil(progressText);

  const [updateModal, setUpdateModal] = useState(false);

  const toggleModal = () => {
    setUpdateModal(!updateModal);
  };

    useEffect(() => {
        setPageTitle("userCampaign");
        document.title="User Campaign details - Mosquepay"
      },[setPageTitle]);
    
    return (
      <div>
        <Spinner loading={useSelector((state) => state.user).loading} />
        <Back />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
          <div className="grid mt-5 lg:col-span-8">
          <div className="grid mb-2">
            <span className="font-medium text-secondary">Campaign title:</span>
            <span className="ubuntu-font font-bold text-sm">{campaignDetail?.title}</span>
          </div>
            <img src={campaignImageURL + campaignDetail?.image} alt="" className="aspect-video md:aspect-auto md:h-[300px] w-full object-cover rounded"/>
            <div className="mt-4">
              <div className="text-[#c4c4c4]">
                <span className="text-[32px]">{formatedProgress}%</span>{" "}
                <span>complete</span>
              </div>
              <div className="grid gap-1 w-full md:w-[60%]">
                <div className="w-full rounded-md bg-secondaryBackground p-[2px] flex items-center">
                  <div
                    className="bg-brandGreen h-[2px] transition-all"
                    style={{ width: progress }}
                  ></div>
                </div>
                <p className="text-sm text-secondary truncate">
                  {" "}
                  &#8358;{campaignDetail?.amount_raise} out of &#8358;
                  {campaignDetail?.amount}
                </p>
              </div>
            </div> 

            {/* <GenerateCampaignFlyer /> */}

            {/* Updates */}
            <div className="mt-10">
              <div className="flex gap-2 items-center mb-4">
                <img src={updatesIcon} alt="" className="h-[18px]" />
                <p className="font-medium text-secondary">Updates:</p>
              </div>

              {updates.length === 0 ? (
                <p className="mb-4">
                  Let your donors know how your fundraising is going. Giving
                  them regular updates can inspire more donations
                </p>
              ) : (
                <div className="grid gap-4 mb-6">
                  {updates.slice(-3).map((update, index) => (
                    <div
                      key={index}
                      className="pb-4 last:pb-0 border-b last:border-0"
                    >
                      <div className="text-secondary">{update.time_in}</div>
                      <div>{update.comment}</div>
                    </div>
                  ))}
                </div>
              )}
              <Button
                buttonRole={"custom"}
                buttonText={"Write an update"}
                otherStyles={"bg-black text-white w-fit"}
                onClick={toggleModal}
              />
            </div>
            
          </div>
          <div className="lg:col-span-4 relative">
            <div className="border rounded md:sticky md:top-24">
              <div className="p-4 bg-secondaryBackground border-b ubuntu-font font-semibold text-sm">
                Campaign donations
              </div>
              <Donations campaignReference={campaignReference} />
            </div>
          </div>
        </div>
        {/* write an update */}
        {updateModal && (
          <div className="bg-black/80 fixed top-0 right-0 left-0 z-50 min-h-screen transition-all duration-300 flex items-center justify-center">
            <div className="p-4 md:p-8 bg-white rounded-md border border-[#c4c4c424] w-full md:w-[40%] m-4">
              <div className="grid">
                <div className="flex justify-end gap-4">
                  <span
                    className="border border-lightPrimary rounded p-2 cursor-pointer"
                    onClick={toggleModal}
                  >
                    Close
                  </span>
                </div>
                <div className="">
                  <p className="font-medium">Write an update</p>
                  <span className="text-sm text-secondary">
                    Providing regular updates can inspire more donations
                  </span>
                </div>
                <form onSubmit={sendUpdatesForm.handleSubmit} className="grid gap-4 mb-4 mt-6">
                  <textarea
                    className="w-full px-4 py-5 md:py-4 border text-sm focus:outline focus:outline-brandGreen/50 rounded"
                    rows={6}
                    name={"comment"}
                    value={sendUpdatesForm.values.comment}
                    onChange={sendUpdatesForm.handleChange}
                    onBlur={sendUpdatesForm.handleBlur}
                  ></textarea>
                  <span>
                    {sendUpdatesForm.touched.comment &&
                      sendUpdatesForm.errors.comment
                        ? sendUpdatesForm.errors.comment
                        : null}
                  </span>
                  <Button
                    buttonText={"Send update"}
                    otherStyles={"bg-black text-white w-fit"}
                    loading={loading}
                  />
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    );
}
 
export default UserCampaignDetail;